import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

/**
 * The three mandatory legal pages linked from the footer.
 *
 * They deliberately do not appear in the main navigation (see ../nav), only in the footer —
 * the usual structure of public administration websites. Paths and titles are German.
 */
export const legalPagesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'barrierefreiheit',
      params: {
        path: '/barrierefreiheit',
        title: 'Erklärung zur Barrierefreiheit',
        loader: () =>
          import('./AccessibilityPage').then(m => <m.AccessibilityPage />),
      },
    }),
    PageBlueprint.make({
      name: 'impressum',
      params: {
        path: '/impressum',
        title: 'Impressum',
        loader: () => import('./ImprintPage').then(m => <m.ImprintPage />),
      },
    }),
    PageBlueprint.make({
      name: 'datenschutz',
      params: {
        path: '/datenschutz',
        title: 'Datenschutz',
        loader: () => import('./PrivacyPage').then(m => <m.PrivacyPage />),
      },
    }),
  ],
});
